import { render, staticRenderFns } from "./PlatformChip.vue?vue&type=template&id=51d12a45"
import script from "./PlatformChip.vue?vue&type=script&lang=js"
export * from "./PlatformChip.vue?vue&type=script&lang=js"
import style0 from "./PlatformChip.vue?vue&type=style&index=0&id=51d12a45&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports